import { proxy } from 'valtio';
import type { AIFeature, AIPlanType } from '@polybank/shared';

export interface AIUpgradeState {
  open: boolean;
  feature: AIFeature | null;
  plan: AIPlanType;
}

export const aiUpgradeProxy = proxy<AIUpgradeState>({
  open: false,
  feature: null,
  plan: 'free',
});

export const aiUpgradeActions = {
  show: (feature: AIFeature, plan: AIPlanType) => {
    aiUpgradeProxy.open = true;
    aiUpgradeProxy.feature = feature;
    aiUpgradeProxy.plan = plan;
  },
  hide: () => {
    aiUpgradeProxy.open = false;
  },
};
